import { writable } from "svelte/store";

export const languages = writable(null);
export const letters = writable(null);
export const topics = writable(null);
export const topicData = writable(null);

export const letterData = writable(null);
export const selectedLanguage1 = writable(null);
export const selectedLanguage2 = writable(null);
export const user = writable(null);
export const userLoggedIn = writable(null);
export const loadingData = writable(null);
export const route = writable(null);

export function setLanguages(value) {
  languages.set(value);
}
export function setLetters(value) {
  letters.set(value);
}
export function setTopics(value) {
  topics.set(value);
}
export function setTopicData(value) {
  topicData.set(value);
}
export function setLetterData(value) {
  letterData.set(value);
}
export function setLanguage1(value) {
  selectedLanguage1.set(value);
}
export function setLanguage2(value) {
  selectedLanguage2.set(value);
}
export function setUserLoggedIn(value) {
  userLoggedIn.set(value);
}
export function setUser(value) {
  user.set(value);
}
export function setLoadingData(value) {
  loadingData.set(value);
}
export function setRoute(value) {
  route.set(value);
}
/**
 * Resets all store values
 */
export function reset() {
  setLanguages(null);
  setLetters(null);
  setTopicData(null);
  setTopics(null);
  setLetterData(null);
  setLanguage1(null);
  setLanguage2(null);
  setUserLoggedIn(false);
  setUser(null);
  setLoadingData(false);
  setRoute("login");
  localStorage.removeItem("token");
}
